<template>
    <img loading="lazy" />
</template>
